import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "От боковых сторон (мм)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "От торца (мм)", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "От ворот (мм)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "От потолка (мм)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Наименование...",
          "show-clear-button": true,
          value: model.name,
          "onUpdate:value": ($event: any) => ((model.name) = $event),
          hasEmptyValue: false,
          validationGroup: validationGroup
        }, null, 8, ["value", "onUpdate:value", "validationGroup"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "От боковых сторон...",
          min: 0,
          value: model.sidesGap,
          "onUpdate:value": ($event: any) => ((model.sidesGap) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "От торца...",
          min: 0,
          value: model.endGap,
          "onUpdate:value": ($event: any) => ((model.endGap) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "От ворот...",
          min: 0,
          value: model.doorsGap,
          "onUpdate:value": ($event: any) => ((model.doorsGap) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "От потолка...",
          min: 0,
          value: model.roofGap,
          "onUpdate:value": ($event: any) => ((model.roofGap) = $event)
        }, null, 8, ["value", "onUpdate:value"])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}